import React, { useEffect, useState } from 'react';
import styles from './forgotPassword.module.scss';
import {
  IoMail,
  IoLockClosed,
  IoLockOpen,
  IoEyeOffSharp,
  IoEyeSharp
} from 'react-icons/io5';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Redirect } from 'react-router';
import { ROUTES } from '../../routing/routes';
import { RootState } from '../../redux';
import CInput from '../../components/input/input';
import CButton from '../../components/button/button';
import { useForgotPasswordMutation, useLoginMutation } from '../../api';
import { useHistory } from 'react-router';

const ForgotPassword = () => {
  const [loginError, setLoginError] = useState('');

  const [form, setForm] = useState({
    email: ''
  });

  const [forgotPassword, { isSuccess, error }] = useForgotPasswordMutation();
  const dispatch = useAppDispatch();

  const session = useAppSelector((state: RootState) => state.session.auth);

  const updateForm = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setForm(state => ({ ...state, [name]: value }));
  };

  useEffect(() => {
    if (error) {
      setLoginError('Adresa de e-mail nu exista in baza de date');
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (isSuccess) {
      setLoginError('A fost trimis un e-mail pentru resetarea parolei.');
    }
  }, [isSuccess, dispatch]);

  const handleSubmit = (event: React.MouseEvent) => {
    event.preventDefault();
    const email = {
      email: form.email
    };

    forgotPassword(email);
  };

  if (session) {
    return <Redirect to={ROUTES.HOME} />;
  }

  return (
    <div className={styles.container}>
      <form>
        <h1>Resetare parolă</h1>
        {loginError && <h2>{loginError}</h2>}
        <CInput
          label='Email'
          icon={<IoMail />}
          type='email'
          id='username'
          placeholder='Introduceti email-ul'
          name='email'
          value={form.email}
          onChange={updateForm}
          required
        />

        <CButton
          label='Resetați parola'
          type='submit'
          onClick={handleSubmit}
          className={styles.loginButton}
        />
      </form>
    </div>
  );
};

export default ForgotPassword;
